import { createTheme } from "@mui/material/styles";

export const createAppTheme = (mode: "light" | "dark") => {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: mode === "dark" ? "#90caf9" : "#1976d2",
      },
      secondary: {
        main: mode === "dark" ? "#f48fb1" : "#dc004e",
      },
      background: {
        default: mode === "dark" ? "#121212" : "#f5f5f5",
        paper: mode === "dark" ? "#1e1e1e" : "#ffffff",
      },
      text: {
        primary: mode === "dark" ? "#ffffff" : "#000000",
        secondary: mode === "dark" ? "#b0b0b0" : "#b0b0b0",
      },
      ...(mode === "dark" && {
        // Custom colors for dark mode
        custom: {
          drawer: "#2d2d2d",
          drawerText: "#ffffff",
          drawerSelected: "rgba(255, 255, 255, 0.1)",
          drawerHover: "rgba(255, 255, 255, 0.05)",
          appBar: "#2d2d2d",
        },
      }),
      ...(mode === "light" && {
        // Custom colors for light mode
        custom: {
          drawer: "#353a40",
          drawerText: "#ffffff",
          drawerSelected: "rgba(255, 255, 255, 0.1)",
          drawerHover: "rgba(255, 255, 255, 0.05)",
          appBar: "#353a40",
        },
      }),
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            transition: "background-color 0.3s ease, color 0.3s ease",
          },
        },
      },
    },
  });
};

// Extend the Theme type to include custom colors
declare module "@mui/material/styles" {
  interface Palette {
    custom?: {
      drawer: string;
      drawerText: string;
      drawerSelected: string;
      drawerHover: string;
      appBar: string;
    };
  }
  interface PaletteOptions {
    custom?: {
      drawer: string;
      drawerText: string;
      drawerSelected: string;
      drawerHover: string;
      appBar: string;
    };
  }
}
